<template>
  <div class="modal-dialog myModalD" v-if="showSelectDialog">
    <div class="modalHeader">
      <span class="title">{{ title }}</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>
    <p>{{ desc }}</p>
    <div v-if="Object.keys(objectFields).length > 0">
      <div class="combo-ms form-group">
        <h4>Update Prefix</h4>
        <input class="form-control" type="text" v-model="prefix" placeholder="Type prefix"/>
        <div>
          <button v-if="visiblePrefixButton" :class="buttonUpdatePrefix" @click="updatePrefixMultiple">{{ textButton }}</button>{{ spaceOnPrefix }}
        </div>
      </div>

      <hr>

      <div class="combo-ms form-group space-combo">
        <h4>Update Model</h4>
        <input class="form-control" type="text" v-model="model" placeholder="Type model"/>
        <div>
          <button :class="buttonUpdateModel" @click="updateModelMultiple">{{ textButton }}</button>
        </div>
      </div>

      <hr>

      <div class="combo-ms form-group space-combo">
        <h4>Field Group</h4>
        <select v-if="Object.keys(fieldNames).length" class="form-control" v-model="fieldGroup" @change="changeGroup">
          <option value="none">None</option>
          <option v-for="(name, index) in fieldNames" :value="index" :key="index">{{ name }}</option>
        </select>
        <button class="btn btn-success" @click="createFieldGroup">New Group</button>
      </div>

      <hr>

      <div class="combo-ms form-group space-combo">
        <h4>Checkbox Group</h4>
        <select v-if="Object.keys(checkboxNames).length" class="form-control" v-model="checkboxGroup" @change="changeCheckboxGroup">
          <option value="none">None</option>
          <option v-for="(name, index) in checkboxNames" :value="index" :key="index">{{ name }}</option>
        </select>
        <button class="btn btn-success" @click="createCheckboxGroup">New Group</button>
      </div>

      <hr>

      <div v-if="Object.keys(sectionNames).length > 0" class="combo-ms form-group">
        <h4>Add to Section</h4>
        <select class="form-control" v-model="sectionName" @change="addToSection">
          <option value="none">None</option>
          <option v-for="(section, index) in sectionNames" :value="index" :key="index">{{ section.originalValue }}</option>
        </select>

        <hr>
      </div>

      <div v-else>
        <h4>No Sections</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'multiple-select-dialog',

  data () {
    return {
      title: 'Modal Title',
      desc: 'The description of the modal',
      confirmAction: '',
      cancelAction: '',
      textButton: 'Update',
      cancelText: 'Cancel',
      showSelectDialog: false,
      dataFields: [],
      objectFields: {},
      prefix: '',
      model: '',
      buttonUpdatePrefix: 'btn btn-primary active',
      buttonUpdateModel: 'btn btn-primary active',
      visiblePrefixButton: false,
      visibleModelButton: false,
      fieldNames: [],
      checkboxNames: [],
      currentFieldGroup: 'none',
      currentCheckboxGroup: 'none',
      fieldGroup: 'none',
      checkboxGroup: 'none',
      sectionNames: {},
      sectionName: ''
    }
  },

  mounted () {
    let that = this
    this.$bus.on('showSelectDialog', function (data) {
      that.dataFields = data.dataFields
      that.title = data.title
      that.desc = data.desc
      that.showSelectDialog = true
      that.setSelectFields()
      that.fieldNames = that.$store.getters.groupFieldNames()
      that.checkboxNames = that.$store.getters.chGroupCheckboxNames()
      that.getSections()
    })
  },

  computed: {
    spaceOnPrefix: function () {
      let prefix = this.prefix
      if (prefix.trim() !== '') this.visiblePrefixButton = true
      else this.visiblePrefixButton = false
    }
  },

  methods: {
    addToSection (e) {
      this.$store.commit('addFieldsToSection', {
        sectionIndex: e.target.value,
        dataFields: this.objectFields
      })
      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire')
    },

    getSections () {
      let sections = this.$store.getters.getSections()
      this.sectionNames = sections
    },

    changeCheckboxGroup (e) {
      if (e.target.value === this.currentCheckboxGroup) return

      if (e.target.value !== 'none') {
        let dataFields = this.objectFields

        let arrayTabsOrder = []
        Object.keys(dataFields).forEach(fieldId => {
          arrayTabsOrder.push(dataFields[fieldId].tabOrder)
        })

        Object.keys(dataFields).forEach(fieldId => {
          this.$store.commit('deleteExistOnCheckboxGroups', dataFields[fieldId].name)
          let fieldData = this.$store.getters.getTemplateData(dataFields[fieldId].name)
          this.$store.commit('addCheckboxToGroup', {
            index: e.target.value,
            fieldId: dataFields[fieldId].name,
            dataField: fieldData
          })
        })
      } else {
        this.$store.commit('removeCheckboxGroup', this.currentCheckboxGroup)
      }

      this.currentCheckboxGroup = e.target.value

      this.$store.dispatch('saveTemplate')
      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire')
      this.checkboxNames = this.$store.getters.chGroupCheckboxNames()
    },

    changeGroup (e) {
      if (e.target.value === this.currentFieldGroup) return

      if (e.target.value !== 'none') {
        let dataFields = this.objectFields

        let arrayTabsOrder = []
        Object.keys(dataFields).forEach(fieldId => {
          arrayTabsOrder.push(dataFields[fieldId].tabOrder)
        })

        Object.keys(dataFields).forEach(fieldId => {
          this.$store.commit('deleteExistOnFieldGroups', dataFields[fieldId].name)
          let fieldData = this.$store.getters.getTemplateData(dataFields[fieldId].name)
          this.$store.commit('addFieldToGroup', {
            index: e.target.value,
            fieldId: dataFields[fieldId].name,
            dataField: fieldData
          })
        })
      } else {
        this.$store.commit('removeFieldGroup', this.currentFieldGroup)
      }

      this.currentFieldGroup = e.target.value

      this.$store.dispatch('saveTemplate')
      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire')
      this.fieldNames = this.$store.getters.groupFieldNames()
    },

    createCheckboxGroup () {
      let dataFields = this.objectFields
      let baseGroup = {}
      let arrayTabsOrder = []
      // let checkboxes = {}
      Object.keys(dataFields).forEach(fieldId => {
        arrayTabsOrder.push(dataFields[fieldId].tabOrder)
      })
      let menorTab = Math.min.apply(null, arrayTabsOrder)

      Object.keys(dataFields).forEach(fieldId => {
        if (dataFields[fieldId].type !== 'checkbox') {
          window.swal({
            title: 'Only select Checkbox for this function',
            text: 'Are you sure you want to continue?',
            icon: 'warning',
            buttons: true,
            dangerMode: true
          })

          const highlighted = document.querySelectorAll('.id-highlight')
          for (const highlight of highlighted) {
            highlight.classList.remove('id-highlight')
          }
          this.prefix = ''
          this.model = ''
          this.dataFields = []
          this.objectFields = {}
          this.showSelectDialog = false
          this.fieldGroup = 'none'
          this.checkboxGroup = 'none'
          this.currentFieldGroup = 'none'
          this.currentCheckboxGroup = 'none'
          return
        }
        if (dataFields[fieldId].tabOrder === menorTab) baseGroup = dataFields[fieldId]

        // checkboxes[dataFields[fieldId].id] = dataFields[fieldId]

        this.$store.commit('deleteExistOnCheckboxGroups', dataFields[fieldId].name)
      })

      if (Object.keys(baseGroup).length === 0) return

      let checkboxes = this.$store.getters.orderFieldGroupFields(dataFields)

      let newGroupId = Math.random().toString(36).split('.')[1]
      let newGroup = {
        name: 'New Group - ' + newGroupId,
        fieldAdd: baseGroup.id,
        title: baseGroup.translations['en'].label,
        desc: baseGroup.translations['en'].text,
        checked: [],
        checkboxes: checkboxes,
        tabOrder: baseGroup.tabOrder,
        page: baseGroup.fieldPage
      }

      this.$store.dispatch('createCheckboxGroup', {
        index: newGroupId,
        data: newGroup
      })
      this.checkboxNames = this.$store.getters.chGroupCheckboxNames()
      let newId = this.$store.getters.checkboxGroup(baseGroup.name)
      this.checkboxGroup = newId
      this.currentCheckboxGroup = newId
      this.$store.dispatch('saveTemplate')
    },

    createFieldGroup () {
      let dataFields = this.objectFields
      let baseGroup = {}
      let arrayTabsOrder = []
      Object.keys(dataFields).forEach(fieldId => {
        arrayTabsOrder.push(dataFields[fieldId].tabOrder)
      })
      let menorTab = Math.min.apply(null, arrayTabsOrder)

      Object.keys(dataFields).forEach(fieldId => {
        let isWidget = this.$store.getters.getIfExistFieldOnWidget(dataFields[fieldId].name)
        if (isWidget) {
          window.swal({
            title: 'Some fields you chose belong to a widget',
            text: 'Fields belong to widgets do not add to Field-Group',
            icon: 'warning',
            buttons: true,
            dangerMode: true
          }).then(deleted => {
            if (!deleted) this.closeModal()
          })

          delete dataFields[fieldId]

          return
        }

        if (dataFields[fieldId].tabOrder === menorTab) baseGroup = dataFields[fieldId]

        this.$store.commit('deleteExistOnFieldGroups', dataFields[fieldId].name)
      })

      if (Object.keys(baseGroup).length === 0) return

      let newGroupId = Math.random().toString(36).split('.')[1]
      let newFields = this.$store.getters.orderFieldGroupFields(dataFields)
      let newGroup = {
        name: 'New Group - ' + newGroupId,
        fieldAdd: baseGroup.id,
        title: baseGroup.translations['en'].label,
        desc: baseGroup.translations['en'].text,
        checked: [],
        fields: newFields,
        tabOrder: baseGroup.tabOrder,
        page: baseGroup.fieldPage
      }

      this.$store.dispatch('createFieldGroup', {
        index: newGroupId,
        data: newGroup
      })
      this.fieldNames = this.$store.getters.groupFieldNames()
      let newId = this.$store.getters.fieldGroup(baseGroup.name)
      this.fieldGroup = newId
      this.currentfieldGroup = newId
      this.$bus.emit('setOnlyFieldGroup', newGroupId)
      this.$store.dispatch('saveTemplate')
    },

    updatePrefixMultiple () {
      let that = this
      let prefix = this.prefix
      this.buttonUpdatePrefix = 'btn btn-primary disabled'
      this.textButton = 'Processing...'
      setTimeout(function () {
        Object.keys(that.objectFields).forEach(fieldIndex => {
          let data = {
            fieldName: that.objectFields[fieldIndex].name,
            prefix: prefix.trim()
          }
          that.$store.commit('updatePrefixTemplate', data)
          that.$store.commit('updatePrefixQuestionnaire', data)
        })
        that.$store.dispatch('saveTemplate')
        that.buttonUpdatePrefix = 'btn btn-primary active'
        that.textButton = 'Update'
        that.prefix = ''
      }, 1000)
    },

    updateModelMultiple () {
      let that = this
      let model = this.model
      this.buttonUpdateModel = 'btn btn-primary disabled'
      this.textButton = 'Processing...'
      setTimeout(function () {
        Object.keys(that.objectFields).forEach(fieldIndex => {
          let data = {
            fieldName: that.objectFields[fieldIndex].name,
            model: model.trim()
          }
          that.$store.commit('updateModelTemplate', data)
          that.$store.commit('updateModelQuestionnaire', data)
        })
        that.$store.dispatch('saveTemplate')
        that.buttonUpdateModel = 'btn btn-primary active'
        that.textButton = 'Update'
        that.model = ''
        const currentTemplate = that.$store.state.currentTemplateName
        that.$store.commit('setCurrentTemplateName', 'global')
        that.$bus.emit('setCurrentTemplateName', 'global')
        that.$store.commit('setCurrentTemplateName', currentTemplate)
        that.$bus.emit('setCurrentTemplateName', currentTemplate)
        that.$store.commit('setLastSaved', Date.now())
      }, 1000)
    },

    setSelectFields () {
      this.dataFields.forEach((field, index) => {
        this.objectFields[index] = field
      })
    },

    closeModal () {
      const highlighted = document.querySelectorAll('.id-highlight')
      for (const highlight of highlighted) {
        highlight.classList.remove('id-highlight')
      }
      this.prefix = ''
      this.model = ''
      this.dataFields = []
      this.objectFields = {}
      this.showSelectDialog = false
      this.fieldGroup = 'none'
      this.checkboxGroup = 'none'
      this.currentFieldGroup = 'none'
      this.currentCheckboxGroup = 'none'
    }
  },

  beforeDestroy () {
    this.$bus.$off('showSelectDialog')
  }
}
</script>

<style lang="scss" scoped>
  .combo-ms {
    height: 80px;
  }
  .modal-dialog {
    margin: auto;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: white;
    border: 2px solid black;
    border-radius: 8px;
    height: 700px;
    padding: 10px;
    user-select: none;
    z-index: 2000;

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 24px;
      padding: 5px 10px 5px 10px;
      height: 46px;
    }

    h1 {
      text-align: center;
    }

    button {
      background-color: #2d5f8b;
      color: white;
      border: none;
      box-shadow: 2px 2px 2px #555;
      min-width: 100px;
      min-height: 35px;
      float: right;
      margin-left: 25px;

      &:hover {
        background-color: #2C7FFF;
        box-shadow: 2px 2px 2px #333;
      }

      &:active {
        box-shadow: 1px 1px 1px #333;
      }

      &:focus {
        outline: none;
      }
    }
  }

  .btn-close:hover {
    color: rgb(228, 226, 226);
  }

  .myModalD{
    pointer-events: auto;
    overflow: auto;
  }

  .space-combo{
    margin-bottom: 38px;
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/modals/MultipleSelectDialog.vue